export default "__VITE_ASSET__rjdQx41G__"